import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CrookedStar, FourPointStar } from "../../assets";

const Onboarding = () => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("belum");

  const handleSelection = (option) => {
    setSelectedOption(option);

    if (option === "belum") {
      navigate("/PlacementTest");
      return;
    }

    navigate("/readiness-checker");
  };

  const getOptionClass = (option) => {
    const isActive = selectedOption === option;

    return [
      "st-focus-ring st-font-body inline-flex h-11 min-w-[120px] items-center justify-center rounded-full px-8 text-[28px] font-bold transition-all duration-200",
      isActive
        ? "bg-[#BB230B] text-white shadow-[0_5px_10px_rgba(0,0,0,0.16)]"
        : "bg-[#9D9D9D] text-[#F3F3F3] hover:bg-[#8E8E8E]",
    ].join(" ");
  };

  return (
    <section id="onboarding" className="scroll-mt-28 st-surface-cream px-4 py-12 sm:px-6 sm:py-14">
      <div className="mx-auto w-full max-w-6xl overflow-hidden rounded-[2px] bg-[#FFFAEE] px-6 py-12 sm:px-10 sm:py-14">
        <div className="relative text-center">
          <div className="pointer-events-none absolute inset-0 hidden sm:block" aria-hidden="true">
            <img
              src={FourPointStar}
              alt=""
              className="absolute left-[4%] top-[30%] w-[72px] md:left-[-2%] md:top-[24%] md:w-[64px] lg:left-[-1%] lg:top-[26%] lg:w-[96px] xl:w-[108px]"
              loading="lazy"
            />
            <img
              src={CrookedStar}
              alt=""
              className="absolute right-[4%] top-[38%] w-[108px] md:right-[-6%] md:top-[24%] md:w-[92px] lg:right-[-3%] lg:top-[40%] lg:w-[150px] xl:w-[170px]"
              loading="lazy"
            />
          </div>

          <p className="st-font-body text-[24px] font-bold leading-tight text-[#1E1E1E] sm:text-[26px]">
            Seberapa siap kamu meraih beasiswa impianmu?
          </p>
          <p className="st-font-body mt-2 text-[18px] text-[#4A4A4A] sm:text-[20px]">
            Cek dalam 1 menit gratis & tanpa ribet
          </p>

          <h2 className="st-font-display mt-8 text-[44px] leading-[1.08] text-[#111111] sm:text-[54px] lg:text-[62px]">
            Kamu sudah pernah ikut
            <br />
            tes <em>IELTS</em>?
          </h2>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <button type="button" onClick={() => handleSelection("belum")} className={getOptionClass("belum")}>
              Belum
            </button>
            <button type="button" onClick={() => handleSelection("sudah")} className={getOptionClass("sudah")}>
              Sudah
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Onboarding;
